(function ($, Drupal) {
    Drupal.behaviors.form_floating_labels = {
        attach: function (context, settings) {
            var formInput = $("form .form-item input, form .form-item select");
            $(formInput, context).removeClass('active');

            $(formInput, context).change(function () {
              handleClass(this);
            });

            $(formInput, context).each(function () {
              handleClass(this);
            });

            $(formInput, context).on("blur", function () {
              handleClass(this);
            });

            function handleClass(element) {
              if ($(element).val()) {
                $(element).addClass('active');
              } else {
                $(element).removeClass('active');
              }
              if($(element).hasClass('form-select')) {
                $(element).addClass('active');
              }
            }
        }
    };
})
(jQuery, Drupal);
